import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

const labelSx: SxProps<Theme> = { display: 'block', mb: 1, fontSize: '0.8125rem', fontWeight: 600 };
const requiredMarkSx: SxProps<Theme> = { color: 'error.main' };

/** A field's label, above it, with the red required mark. */
export function FieldLabel({
  htmlFor,
  id,
  required = true,
  children,
}: {
  htmlFor?: string;
  id?: string;
  required?: boolean;
  children: ReactNode;
}) {
  return (
    <Typography component="label" htmlFor={htmlFor} id={id} sx={labelSx}>
      {children}
      {required ? (
        <>
          {' '}
          <Box component="span" sx={requiredMarkSx}>
            *
          </Box>
        </>
      ) : null}
    </Typography>
  );
}
